// The browser admission is supplied per deployment, never baked into a shared image.
export function supportPhoneChangeEnabled(): boolean {
  return window.__MAGISTIKA_RUNTIME_CONFIG__?.supportPhoneChangeEnabled === true;
}
